<p-confirmDialog key="fine" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Grid-->
<div class="MainGrid2Col">
	<label>Group:</label>
	<label>{{ SelectedGroupName }}</label>

	<label>Date:</label>
	<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="ActionDate" name="ActionDate"></p-calendar>

	<label>Fine Type:</label>
	<select class="form-control" name="SelectedFineType" [(ngModel)]="SelectedFineType" (ngModelChange)="onFineTypeChange($event)">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstFineType" [ngValue]="o">
			{{ o.AccountDebitTypeDesc }}
		</option>
	</select>

	<!-- <label>Administrator:</label>
    <select class="form-control" name="AdminPersonID" [(ngModel)]="AdminPersonID">
        <option value="" style="display:none;"></option>
        <option *ngFor="let o of lstAdminUsers" [ngValue]="o.AdministratorID">{{o.Administrator}}</option>
    </select> -->

	<label>Amount:</label>
	<!-- <input class="form-control" id="SelectedFineAmount" [(ngModel)]="SelectedFineAmount" type="string"> -->
	<p-inputNumber
		id="SelectedFineAmount"
		[(ngModel)]="SelectedFineAmount"
		mode="currency"
		currency="USD"
		locale="en-US"
		step="0.01"
		[showButtons]="true"
	></p-inputNumber>

	<label>Comments:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="Comments"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddFine()">Add Fine</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="form-group TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
